import Link from '@/routing/AppLink';
import React from 'react';

import theme from '@/styles/theme';

import { IconArrowRightRound } from '../icon';

export type IndicatorItemType = {
  text: React.ReactNode;
  href: string;
  isActive?: boolean;
};

/**
 * ::after 밑줄의 높이/배경색은 isActive 하나로 동시에 갈리므로,
 * 같은 속성을 두 클래스로 흘리지 않도록 JS에서 승자를 계산해 한 벌만 내보낸다.
 */
function underlineClass(isActive: boolean) {
  return isActive
    ? 'after:h-[3px] after:bg-apps-corePrimary01'
    : 'after:h-[1px] after:bg-apps-coreProductDivider';
}

export default function IndicatorItem({
  text,
  href,
  isActive = false,
}: IndicatorItemType) {
  /** 클릭 시 해당 섹션으로 스크롤 이동  */
  const handleScroll = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    event.preventDefault();
    const targetElement = document.querySelector(href);
    if (targetElement) {
      const header = document.querySelector('header') as HTMLElement;
      const headerHeight = header.clientHeight;

      const targetPosition = targetElement.getBoundingClientRect().top;

      window.scrollTo({
        top: window.scrollY + targetPosition - headerHeight,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div
      className={`relative after:absolute after:bottom-0 after:left-0 after:w-full after:transition-[background-color] after:duration-300 after:ease-[ease] after:content-[''] ${underlineClass(
        isActive,
      )}`}
    >
      {/* 원본의 @media (hover: hover) 는 Tailwind 의 group-hover 가 그대로 감싸주므로 별도 처리 불필요 */}
      <Link
        href={href}
        onClick={handleScroll}
        className="group/indicator-link flex h-full min-h-[72px] w-[227px] items-center justify-between gap-[8px] text-[20px] font-bold leading-[160%] tracking-[-0.4px] text-apps-coreGrayBlack"
      >
        {text}
        <div className="opacity-0 transition-opacity duration-300 ease-[ease] group-hover/indicator-link:opacity-100">
          <IconArrowRightRound
            size={28}
            color={theme`colors.apps.brandGrayBlack`}
          />
        </div>
      </Link>
    </div>
  );
}
